// import

import { useParams } from "react-router-dom";
import { Alert, Card, Chip, Switch, Typography } from "@mui/material";
import { useCallback, useState } from "react";

import TagDetailsStyle from "./style";

import ContentTable, { createData } from "@/components/app/ContentTable";
import DashboardHeader from "@/components/app/DashboardHeader";
import DashboardContent from "@/components/app/DashboardContent";
import { useContentsList } from "@/api/hooks/useContents";
import { IContentsParams } from "@/api/types/content";
import { useTagByID } from "@/api/hooks/useTags";

export default function TagDetails() {
    const { id } = useParams();
    const [params, setParams] = useState<IContentsParams>({
        skip: 0,
        take: 10,
        filter: {
            tag: Number(id) || null,
        },
    });

    const { data: TagDetails } = useTagByID(Number(id));
    const { data: ContentData, isLoading, isFetching, isPending } = useContentsList(params);

    const Data = ContentData?.data.items.map((item) => createData(item));

    const handleChange = useCallback(({ page, rowsPerPage }: { page?: number, rowsPerPage?: number }) => {
        setParams((prev) => {
            return {
                ...prev,
                skip: Number(page) * Number(rowsPerPage),
                take: Number(rowsPerPage),
            };
        });
    }, []);

    return (
        <TagDetailsStyle>
            <>
                <DashboardHeader title="Tag Details">
                    <Alert severity="info" sx={{ marginTop: "1em" }}>
                        See the details of this TAG and the related content!
                    </Alert>
                </DashboardHeader>

                <DashboardContent>
                    <Typography className="title" variant="h5">
                        Details
                    </Typography>
                    <Card className="details-card">
                        <Typography>
                            <span className="label">Number of content items assigned to this tag: </span>
                            <span className="value">
                                {" "}
                                <b>( {TagDetails?.data.contentCount || "-"} )</b>{" "}
                            </span>
                        </Typography>
                        <br />
                        <Typography>
                            <span className="label">Classification of assigned content : </span>
                            <span className="value chips-wrapper">
                                {TagDetails?.data.isEducation && (
                                    <Chip color={"success"} label="Education" size="small" variant="outlined" />
                                )}
                                {TagDetails?.data.isEntertainment && (
                                    <Chip color={"info"} label="Entertainment" size="small" variant="outlined" />
                                )}
                            </span>
                        </Typography>
                        <br />
                        <Typography>
                            <span className="label">Is In Active UI: </span>
                            <span className="value">
                                <Switch disabled checked={TagDetails?.data.inUiActive} color="warning" />
                            </span>
                        </Typography>
                    </Card>

                    <Typography className="title" variant="h5">
                        Related Contents
                    </Typography>
                    <ContentTable
                        data={Data || []}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        isPending={isPending}
                        page={Number(params.skip) / Number(params.take)}
                        rowsPerPage={Number(params.take)}
                        totalItems={ContentData ? ContentData.data.pagination.totalItems : 0}
                        onChange={handleChange}
                    />
                </DashboardContent>
            </>
        </TagDetailsStyle>
    );
}
